export default {"src":"/_next/static/media/instagram.fe14131c.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};